module.exports = __webpack_public_path__ + "static/img/irole.fd5fb85.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/tysdags/irole.png
// module id = OO6o
// module chunks = 7